import { useQuery } from '@tanstack/react-query';
import { chatService } from '@/lib/api/services/chat.service';

/**
 * Hook for fetching AI suggestions for a conversation
 * Auto-refreshes when conversationId changes or when new messages arrive
 */
export function useAISuggestions(
  conversationId: string | null,
  enabled: boolean = true,
  refetchTrigger?: number // Increment this to trigger refetch (e.g., when new message arrives)
) {
  const {
    data: result,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['ai-suggestions', conversationId, refetchTrigger],
    queryFn: async () => {
      if (!conversationId) return { suggestions: [], analysis: undefined };
      return await chatService.getAISuggestions(conversationId);
    },
    enabled: enabled && !!conversationId,
    staleTime: 0, // Always refetch when triggered (auto-updates on new messages)
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return {
    suggestions: (result?.suggestions || []).slice(0, 2), // Limit to max 2
    analysis: result?.analysis,
    isLoading,
    isFetching,
    error,
    refetch,
  };
}

